export default class RegisterForm {
    constructor() {
        this.registerModal = "#gmRewardsRegisterModal";
        this.form = document.querySelector("#gmRewardsRegisterForm");
        this.firstNameInput =
            this.form?.querySelector(`[name="FirstName"]`);
        this.lastNameInput =
            this.form?.querySelector(`[name="LastName"]`);
        this.emailInput =
            this.form?.querySelector(`[name="Email"]`);
        this.firstNameError = document.getElementById("firstNameError");
        this.lastNameError = document.getElementById("lastNameError");
        this.emailError = document.getElementById("emailError");
        this.attachEvents();
    }
    attachEvents() {
        const registerLinks = document.querySelectorAll(".registerLink");
        registerLinks.forEach((link) => {
            link.addEventListener("click", (e) => {
                e.preventDefault();
                this.showModal(this.registerModal);
            });
        });
        this.form?.addEventListener("submit", (e) => this.onSubmit(e));
        this.firstNameInput?.addEventListener("input", () => this.clearInputErrorsIfValid("firstName"));
        this.lastNameInput?.addEventListener("input", () => this.clearInputErrorsIfValid("lastName"));
        this.emailInput?.addEventListener("input", () => this.clearInputErrorsIfValid("email"));
        const jq = globalThis.$;
        if (jq) {
            jq(this.registerModal).on("hidden.bs.modal", () => {
                this.clearForm();
            });
        }
    }
    async onSubmit(event) {
        event.preventDefault();
        if (!this.form)
            return;
        this.resetFormStyles();
        if (!this.validate()) {
            return;
        }
        const data = {
            firstName: this.firstNameInput?.value.trim() ?? "",
            email: this.emailInput?.value.trim() ?? "",
        };
        const url = `/api/oemssaa/gm/rewards/invitation`;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });
            if (response.ok) {
                this.showModal("#gmRewardsSuccessModal", true);
                // Form Submission DoTagging
                this.formSubmissionDoTagging();
                this.clearForm();
            }
            else {
                this.showModal("#gmRewardsErrorModal", true);
            }
        }
        catch (err) {
            console.error("Failed to submit rewards form", err);
            this.showModal("#gmRewardsErrorModal", true);
        }
        finally {
            this.showModal(this.registerModal, false);
        }
    }
    showInputErrors(field) {
        switch (field) {
            case "firstName":
                this.firstNameError.textContent = "Must be 2 to 40 characters.";
                this.firstNameInput.classList.add("input-error");
                break;
            case "lastName":
                this.lastNameError.textContent = "Must be 2 to 40 characters.";
                this.lastNameInput.classList.add("input-error");
                break;
            case "email":
                this.emailError.textContent = `Must be a valid email format.`;
                this.emailInput.classList.add("input-error");
                break;
        }
    }
    clearInputErrors(field) {
        switch (field) {
            case "firstName":
                this.firstNameError.textContent = "";
                this.firstNameInput.classList.remove("input-error");
                break;
            case "lastName":
                this.lastNameError.textContent = "";
                this.lastNameInput.classList.remove("input-error");
                break;
            case "email":
                this.emailError.textContent = "";
                this.emailInput.classList.remove("input-error");
                break;
        }
    }
    clearInputErrorsIfValid(field) {
        switch (field) {
            case "firstName":
                if (this.firstNameIsValid(this.firstNameInput.value.trim())) {
                    this.clearInputErrors("firstName");
                }
                break;
            case "lastName":
                if (this.lastNameIsValid(this.lastNameInput.value.trim())) {
                    this.clearInputErrors("lastName");
                }
                break;
            case "email":
                if (this.emailIsValid(this.emailInput.value.trim())) {
                    this.clearInputErrors("email");
                }
                break;
        }
    }
    validate() {
        const firstNameIsValid = this.firstNameIsValid(this.firstNameInput.value.trim());
        if (!firstNameIsValid) {
            this.showInputErrors("firstName");
        }
        const lastNameIsValid = this.lastNameIsValid(this.lastNameInput.value.trim());
        if (!lastNameIsValid) {
            this.showInputErrors("lastName");
        }
        const emailIsValid = this.emailIsValid(this.emailInput.value.trim());
        if (!emailIsValid) {
            this.showInputErrors("email");
        }
        return firstNameIsValid && lastNameIsValid && emailIsValid;
    }
    firstNameIsValid(firstName) {
        return firstName.length >= 2 && firstName.length <= 40;
    }
    lastNameIsValid(lastName) {
        return lastName.length >= 2 && lastName.length <= 40;
    }
    emailIsValid(email) {
        return /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email);
    }
    resetFormStyles() {
        this.clearInputErrors("firstName");
        this.clearInputErrors("lastName");
        this.clearInputErrors("email");
    }
    clearForm() {
        if (!this.form)
            return;
        this.form.reset();
        this.resetFormStyles();
    }
    showModal(selector, show = true) {
        const jq = globalThis.$;
        if (show) {
            jq?.(selector)?.modal?.("show");
        }
        else {
            jq?.(selector)?.modal?.("hide");
        }
    }
    formSubmissionDoTagging() {
        const taggingData = {
            event: "lead_submitted",
            page_type: "home",
            card_name: "GM Rewards Points Balance",
            event_owner: "dealeron",
            comm_type: "form",
            department: "unknown",
            event_action_result: "complete",
            event_action: "click",
            product_name: "GM Rewards Homepage Banner",
            element_text: "Submit",
            form_name: "GM Rewards",
            form_type: "custom",
            submission_id: "-2",
        };
        globalThis.dispatchEvent(new CustomEvent("dotagging.event", {
            bubbles: true,
            detail: {
                data: taggingData,
            },
        }));
    }
}
globalThis.DoUtility.SelfInstantiateOnLoad(RegisterForm);
